/* Respect motion preferences, hidden tabs and off-screen media; no tracking or persistence. */
(function(){
  'use strict';
  if(window.CPMotionControls)return;
  var instances=new Map(),motion=window.matchMedia('(prefers-reduced-motion: reduce)'),mobile=window.matchMedia('(max-width: 749px)');
  function init(scope){
    var roots=Array.from(scope.querySelectorAll('[data-cp-motion-hero]'));
    if(scope.matches&&scope.matches('[data-cp-motion-hero]'))roots.unshift(scope);
    roots.forEach(function(root){
      if(instances.has(root))return;
      var videos=Array.from(root.querySelectorAll('video')),button=root.querySelector('[data-cp-motion-toggle]');
      if(!videos.length||!button)return;
      var manualPause=false,visible=false,observer;
      function active(){return videos.find(function(v){return v.getClientRects().length>0&&getComputedStyle(v).visibility!=='hidden';});}
      function sync(){var v=active();button.hidden=!v;button.textContent=v&&!v.paused&&!v.ended?button.dataset.pauseLabel:button.dataset.playLabel;}
      function play(v){if(!v)return;var result=v.play();if(result&&result.catch)result.catch(sync);}
      function pause(){videos.forEach(function(v){v.pause();});sync();}
      function update(){
        var current=active();videos.forEach(function(v){if(v!==current)v.pause();});
        if(document.hidden||!visible||motion.matches||(navigator.connection&&navigator.connection.saveData)||manualPause){pause();return;}
        if(current&&!current.ended)play(current);sync();
      }
      function toggle(){var v=active();if(!v)return;if(v.paused||v.ended){manualPause=false;play(v);}else{manualPause=true;pause();}}
      videos.forEach(function(v){['play','pause','ended','error'].forEach(function(name){v.addEventListener(name,sync);});});
      button.addEventListener('click',toggle);
      if('IntersectionObserver' in window){observer=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;update();},{threshold:.05});observer.observe(root);}else{visible=true;update();}
      instances.set(root,{update:update,clean:function(){pause();if(observer)observer.disconnect();button.removeEventListener('click',toggle);}});sync();
    });
  }
  function update(){instances.forEach(function(x,root){if(!root.isConnected){x.clean();instances.delete(root);}else x.update();});}
  document.addEventListener('visibilitychange',update);motion.addEventListener('change',update);mobile.addEventListener('change',update);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  document.addEventListener('shopify:section:unload',function(e){instances.forEach(function(x,root){if(e.target.contains(root)){x.clean();instances.delete(root);}});});
  window.CPMotionControls={};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});else init(document);
})();
